import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { XMLHttpRequestHandler_requestType } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminTrackingContracts_template } from '../../components/templates/recruiting/adminTrackingContracts_template';
import { startListLoading, stopListLoading } from '~/utils/listLoading';
export class admin_tracking_contracts extends vnModule_knockoutJS {
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_tracking_contracts';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Contracts');
        this.tpl = new adminTrackingContracts_template('adminTrackingContractsTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        startListLoading(this, this.tpl.builtTemplate);
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/tracking/partners', [], this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for references.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onReferencesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.tpl.setReferences(responseParsed);
                obj.getListData();
            });
        };
    }
    /**
     * Return list data.
     *
     * @return void
     */
    getListData() {
        startListLoading(this, this.tpl.builtTemplate);
        this.sendFilterCall('/api/admin/rest/api/lead/tracking/contracts', this.tpl.getViewModelForRequest(), this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getContracts');
    }
    /**
     * Handle the API response for data request.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                const rows = (responseParsed.data && responseParsed.data.paginatedData) || responseParsed.data || [];
                const vmReq = obj.tpl.getViewModelForRequest();
                const totalCount = Number(responseParsed.totalCount || 0);
                const perPage = vmReq.pagination && vmReq.pagination.itemPerPage ? Number(vmReq.pagination.itemPerPage) : 20;
                const totalPages = Math.max(1, Number(responseParsed.totalPage || Math.ceil(totalCount / Math.max(1, perPage))));
                obj.validationTemplate.clearMessages();
                obj.tpl.setContracts(rows);
                obj.tpl.updatePagination(totalCount);
                obj.tpl.setResultInfo(totalCount, totalPages, Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                stopListLoading(obj, obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Handle pagination click events.
     *
     * @return void
     */
    paginationOnPageClick() {
        this.getListData();
    }
    /**
     * Handle filter on change changes.
     *
     * @return void
     */
    filterOnChange() {
        this.tpl.resetPageNumber();
        this.getListData();
    }
    /**
     * Navigate to create contract.
     *
     * @return void
     */
    createContract() {
        page('/admin/contract/new');
    }
    /**
     * Navigate to edit contract.
     *
     * @param id number
     * @return void
     */
    editContract(id) {
        page('/admin/contract/' + id);
    }
    /**
     * Handle duplicate contract.
     *
     * @param id number
     * @return void
     */
    duplicateContract(id) {
        page('/admin/contract-duplicate/' + id);
    }
}
